const AUTHDETAILSFORTHEPROGRAM = 'auth-details-for-the-program'
const OAUTHURL = 'oauth-url'
const APPENDOAUTHURLWITHREDIRECTURI = 'append-oauth-url-with-redirect-uri'
const APPENDAUTHURLWITHSTATEPARAMETER = 'append-auth-url-with-state-parameter'
const HOAUTHORIZATION = 'ho-authorization'
const RETRIEVEAUTHCODEFROMREDIRECTURI = 'retrieve-auth-code-from-redirect-uri'
const GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN = 'generate-OAuth2-access-token-and-refresh-token'
const REGENERATEACCESSTOKENUSINGREFRESHTOKEN = 'regenerate-access-token-using-refresh-token'
const ENROLLUSINGHOACCESSTOKEN = 'enroll-a-site-using-ho-access-token'

export {
  AUTHDETAILSFORTHEPROGRAM,
  OAUTHURL,
  APPENDOAUTHURLWITHREDIRECTURI,
  APPENDAUTHURLWITHSTATEPARAMETER,
  HOAUTHORIZATION,
  RETRIEVEAUTHCODEFROMREDIRECTURI,
  GENERATEOAUTH2ACCESSTOKENANDREFRESHTOKEN,
  REGENERATEACCESSTOKENUSINGREFRESHTOKEN,
  ENROLLUSINGHOACCESSTOKEN
}